import React, { useState, useEffect } from "react";
import style from "./MaisDisparosStyle";
import PayMoreDisparos from "./PayMoreDisparos/PayMoreDisparos";
import { useNavigate } from "react-router-dom";

const PRECO_POR_DISPARO = 0.08;
const MINIMO_DISPAROS = 5;

export default function MaisDisparos() {
  const [quantidade, setQuantidade] = useState(MINIMO_DISPAROS);
  const [total, setTotal] = useState(0);
  const [erro, setErro] = useState("");
  const [showPayModal, setShowPayModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const numQuantidade = parseInt(quantidade, 10);

    if (isNaN(numQuantidade) || numQuantidade <= 0) {
      setTotal(0);
      setErro("");
      return;
    }

    if (numQuantidade < MINIMO_DISPAROS) {
      setErro(
        `A quantidade mínima para compra é de ${MINIMO_DISPAROS} disparos.`
      );
      setTotal(0);
    } else {
      setErro("");
      const valorCalculado = numQuantidade * PRECO_POR_DISPARO;
      setTotal(valorCalculado);
    }
  }, [quantidade]);

  const handleQuantidadeChange = (e) => {
    const value = e.target.value;
    setQuantidade(value === "" ? "" : Math.max(0, parseInt(value, 10)));
  };

  const handlePaymentSuccess = () => {
    navigate("/disparos");
  };

  return (
    <>
      <div style={style.container}>
        <div style={style.card}>
          <h1 style={style.title}>Comprar Mais Disparos</h1>
          <p style={style.description}>
            Cada disparo custa R$ 0,68. A compra mínima é de {MINIMO_DISPAROS}{" "}
            disparos.
          </p>

          <div style={style.inputGroup}>
            <label style={style.label} htmlFor="quantidadeDisparos">
              Quantidade de disparos desejada
            </label>
            <input
              id="quantidadeDisparos"
              type="number"
              style={style.input}
              value={quantidade}
              onChange={handleQuantidadeChange}
              min={MINIMO_DISPAROS}
              placeholder="Digite a quantidade"
            />
            {erro && <p style={style.errorText}>{erro}</p>}
          </div>

          <div style={style.totalContainer}>
            <span style={style.totalLabel}>Valor total:</span>
            <span style={style.totalValue}>
              {total.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </span>
          </div>

          <button
            onClick={() => setShowPayModal(true)}
            style={
              erro || !quantidade || quantidade < MINIMO_DISPAROS
                ? { ...style.payButton, ...style.disabledButton }
                : style.payButton
            }
            disabled={!!erro || !quantidade || quantidade < MINIMO_DISPAROS}
          >
            Pagar Agora
          </button>
        </div>
      </div>
      {showPayModal && (
        <PayMoreDisparos
          onClose={() => setShowPayModal(false)}
          onSuccess={handlePaymentSuccess}
          totalValue={total}
          quantidade={quantidade}
        />
      )}
    </>
  );
}